export default {
  methods: {
    setupApplyFilterKeyEventListeners() {
      this.applyFilterEventListener = this.applyFilterShortcut.bind(this)
      this.resetKeysEventListener = this.resetKeysPressed.bind(this)
      if (document.addEventListener) {
        document.addEventListener('keydown', this.applyFilterEventListener)
        document.addEventListener('keyup', this.resetKeysEventListener)
      } else if (document.attachEvent) {
        // For IE
        document.attachEvent('keydown', this.applyFilterEventListener)
        document.attachEvent('keyup', this.resetKeysEventListener)
      }
    }
  }
}
